/**
 * Получить локализованное значение из объекта {ua, en}
 * @param {string|object} value - значение или объект с локализацией
 * @param {string} locale - локаль (ua/en)
 * @returns {string} локализованное значение
 */
export function getLocalizedValue(value, locale = 'ua') {
  if (typeof value === 'string') {
    return value;
  }

  if (!value || typeof value !== 'object') {
    return '';
  }

  // Если это объект с ua/en ключами
  if (value[locale]) {
    return value[locale];
  }

  // Fallback на украинский
  if (value.ua) {
    return value.ua;
  }

  // Fallback на английский
  if (value.en) {
    return value.en;
  }

  return '';
}

/**
 * Преобразовать данные для отправки на сервер
 * Если значение это объект {ua, en}, оставить как есть
 * Если строка, создать объект с одинаковыми значениями для ua и en
 * @param {string|object} value - значение
 * @returns {string|object} значение для API
 */
export function normalizeForApi(value) {
  if (!value) {
    return '';
  }

  if (typeof value === 'object') {
    return value;
  }

  // Если это строка, создаём объект {ua, en} с одинаковыми значениями
  return {
    ua: value,
    en: value,
  };
}
